import { CONTRACT_STATUS } from "@/lib/contracts";
import { cn } from "@/lib/utils";
import { useLang } from "@/i18n";

export const ContractStatusBadge = ({ status, className }) => {
  const { tf } = useLang();
  const meta = CONTRACT_STATUS[status] || CONTRACT_STATUS.draft;
  return (
    <span data-testid={`contract-status-${status}`}
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap", meta.cls, className)}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: meta.dot }} />
      {tf(meta.label)}
    </span>
  );
};
